const Orientation = Object.freeze({
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
});
const Themes = Object.freeze({
  DARK: 'dark',
  LIGHT: 'light'
});
const TooltipThemes = Object.freeze({
  ...Themes,
  WARNING: 'warning'
});
const FocusTargets = Object.freeze({
  INPUT: 'input',
  NONE: '',
  SELECT: 'select'
});
const IconNames = Object.freeze({
  ADD: 'add',
  CLEAR: 'clear',
  FILTER: 'filter',
  LOADING: 'loading',
  MAGNIFYING_GLASS: 'magnifyingGlass',
  NONE: 'none',
  SEARCH: 'search',
  SELECT: 'select',
  VALIDATE_SUCCESS: 'validateSuccess'
});
const FormIntent = Object.freeze({
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning'
});
const Position = Object.freeze({
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top'
});
const InputType = Object.freeze({
  BUTTON: 'button',
  CHECKBOX: 'checkbox',
  RADIO: 'radio'
});
const KeyboardKeys = Object.freeze({
  DOWN: 'ArrowDown',
  LEFT: 'ArrowLeft',
  RIGHT: 'ArrowRight',
  UP: 'ArrowUp'
});

export { FormIntent as F, InputType as I, KeyboardKeys as K, Orientation as O, Position as P, TooltipThemes as T, IconNames as a, FocusTargets as b, Themes as c };
